// TODO: Add fetching and using target object in authorization 

import { Injectable } from '@angular/core'
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import * as _ from 'lodash'

import { Authentication } from 'core/auth/authentication.service'
import { IAuthorization } from 'core/auth/i-authorization.service'
import { Constants } from 'config'

@Injectable()
export class RouterAuthorizer implements CanActivate {
  constructor(
    private router: Router,
    private authetication: Authentication,
    private authorization: IAuthorization
  ) {}

  isAuthenticated(): Observable<boolean> {
    return Observable.create(observer => {
      if (this.authetication.currentUser) {
        observer.next(true)
        observer.complete()
      } else {
        this.authetication.validateToken().subscribe(
          response => {
            observer.next(true)
            observer.complete()
          },
          error => {
            observer.next(false)
            observer.complete()
          }
        )
      }
    })
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let authData = route.data['authorization']
    return Observable.create(observer => {
      this.isAuthenticated().subscribe(
        authenticated => {
          if (!authData) {
            observer.next(true)
          }
          else if (authData == 'guestsOnly') {
            if (authenticated) {
              this.router.navigateByUrl('/')
              observer.next(false)
            } else {
              observer.next(true)
            }
          }
          else if (!_.isArray(authData)) {
            console.error('Invalid "authorization" route config. Must be an array with length 2..3 or "guests"')
            observer.next(false)
          }
          else if (authData.length == 2) {
            if(this.authorization.allowed(this.authetication.currentUser, authData[0], authData[1])) {
              observer.next(true)
            } else {
              this.router.navigateByUrl('/')
              observer.next(false)
            }
          }
          else if (authData.length == 3) {
            console.error('Resolving route authorization with target object is not implemented yet')
            observer.next(false)
          }
          else {
            console.error('Invalid "authorization" route config. Must be an array with length 2..3 or "guests"')
            return false
          }

          observer.complete()
        }
      )
    })
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/router/router-authorizer.ts